<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ilStS/tc-custom/9781446358689.jpg?1728327053934" alt="This image is the cover for the book Contemporary Cake Decorating Bible: Flowers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Contemporary Cake Decorating Bible: Flowers
      </h1>
      <p class="bookDescription body article font2">
        <p>Flowers are probably the most popular choice of all cake decorations. The simplest representation of a flower is a cut-out shape. Other more interesting ways of representing flowers are to create fabric-effect flowers out of paste or to try your hand at creating lifelike flowers. There are many books written on the art of sugar flower making; LindySmith touches on this subject here, showing you how to make lifelike poppies and peonies, as well as fabric roses, blossoms and dahlias, and simple cupped flowers.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lindy Smith
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      David & Charles
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6bacf0e5